import React from 'react'
import { useParams } from 'react-router-dom'
import { PageContainer } from 'src/component/page-container/page-container'
import { Membership } from 'src/component/profile/personal-info/membership'
import { PersonalInfo } from 'src/component/profile/personal-info/personal-info'
import { Preferences } from 'src/component/profile/personal-info/preferences'
import { useCheckoutReturn } from 'src/hook/use-checkout-return'

export const ProfilePersonalInfoScreen = (): React.ReactElement => {
  const { checkoutStatus } = useParams<{ checkoutStatus?: string }>()
  useCheckoutReturn({ checkoutStatus })

  return (
    <PageContainer>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-7 py-6 lg:py-[82px]">
        <div className="grid grid-cols-1 gap-5">
          <PersonalInfo />
          <Preferences />
        </div>
        <Membership />
      </div>
    </PageContainer>
  )
}
